import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Materials',
    href: '#materials'
  }, {
    name: 'Partnership',
    href: '#partnership'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-231">
      <div className="container mx-auto px-4 md:px-6" data-id="element-232">
        <div className="flex items-center justify-between" data-id="element-233">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-234">
            <img src="https://cdn.magicpatterns.com/uploads/dSUoJFewu2oS1dagyRHpgT/IconOnly.png" alt="Plastic Engineering Solutions Logo" className="h-10 w-auto object-contain" data-id="element-235" />
            <div className="flex flex-col" data-id="element-236">
              <span className={`font-bold leading-tight ${isScrolled ? 'text-primary' : 'text-primary'}`} data-id="element-237">
                Plastic Engineering
              </span>
              <span className={`text-xs tracking-wider uppercase ${isScrolled ? 'text-gray-600' : 'text-gray-600'}`} data-id="element-238">
                Solutions
              </span>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-239">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-700 hover:text-accent transition-colors" data-id="element-240">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" leftIcon={<Phone className="h-4 w-4" data-id="element-242" />} onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-241">
              Get Consultation
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-243">
            {isMobileMenuOpen ? <X data-id="element-244" /> : <Menu data-id="element-245" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg p-4 flex flex-col gap-4" data-id="element-246">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-gray-700 py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-247">
              {link.name}
            </a>)}
          <Button variant="primary" className="w-full mt-2" onClick={() => {
        setIsMobileMenuOpen(false);
        document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-248">
            Get Consultation
          </Button>
        </div>}
    </header>;
}